module.exports = __webpack_public_path__ + "media/images/projects/10-logo-be8001555bab0deb54206ce0f5117314.png";